import { render, staticRenderFns } from "./PreparationDashboard.vue?vue&type=template&id=cde8887e&scoped=true&"
import script from "./PreparationDashboard.vue?vue&type=script&lang=js&"
export * from "./PreparationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PreparationDashboard.vue?vue&type=style&index=0&id=cde8887e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde8887e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cde8887e')) {
      api.createRecord('cde8887e', component.options)
    } else {
      api.reload('cde8887e', component.options)
    }
    module.hot.accept("./PreparationDashboard.vue?vue&type=template&id=cde8887e&scoped=true&", function () {
      api.rerender('cde8887e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/preparation-dashboard/PreparationDashboard.vue"
export default component.exports